/**
 * Clothify theme — product form logic: variant selection, price/stock/
 * image sync, product gallery, sticky add-to-cart. Works for both the
 * main product page and dynamically-injected quick-add modal content
 * via window.ClothifyProduct.init(scopeEl).
 */
(function () {
  'use strict';

  var theme = window.theme || { settings: {}, strings: {}, moneyFormat: '${{amount}}' };
  var formatMoney = window.ClothifyFormatMoney || function (c) { return c; };

  function renderPriceHtml(variant, product) {
    var onSale = variant && variant.compare_at_price > variant.price;
    var html = '<div class="price' + (onSale ? ' price--on-sale' : '') + '">';
    if (!variant) {
      html += '<span class="price__regular">' + theme.strings.unavailable + '</span>';
    } else if (!variant.available) {
      html += '<span class="price__regular">' + theme.strings.soldOut + '</span>';
    } else {
      if (onSale) {
        html += '<span class="price__compare">' + formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>';
      }
      html += '<span class="price__regular">' + formatMoney(variant.price, theme.moneyFormat) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function renderStockBadgeHtml(variant) {
    var dot = '<span class="stock-badge__dot"></span>';
    if (!variant) return '<div class="stock-badge stock-badge--out">' + dot + theme.strings.unavailable + '</div>';
    if (!variant.available) return '<div class="stock-badge stock-badge--out">' + dot + theme.strings.outOfStock + '</div>';
    var tracks = variant.inventory_management === 'shopify';
    if (tracks && theme.settings.showLowStock && variant.inventory_quantity > 0 && variant.inventory_quantity <= theme.settings.lowStockThreshold) {
      var text = (theme.strings.lowStockTemplate || '').replace('__COUNT__', variant.inventory_quantity);
      return '<div class="stock-badge stock-badge--low">' + dot + text + '</div>';
    }
    return '<div class="stock-badge">' + dot + theme.strings.inStock + '</div>';
  }

  function initProductForm(scope) {
    var wraps = scope.querySelectorAll ? scope.querySelectorAll('[data-product-form]') : [];
    if (scope.matches && scope.matches('[data-product-form]')) {
      wraps = Array.prototype.concat.call([scope], Array.prototype.slice.call(wraps));
    }

    wraps.forEach(function (formWrap) {
      if (formWrap.dataset.productFormInit) return;
      formWrap.dataset.productFormInit = 'true';

      var jsonEl = formWrap.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

      var form = formWrap.querySelector('[data-product-form-el]');
      // All of them, not just the first: the dynamic-checkout button lives in its own
      // small form (Shopify's payment_button needs its own {% form %}) with its own
      // hidden variant-id input, and it has to track the same selection.
      var variantIdInputs = formWrap.querySelectorAll('[data-variant-id]');
      var selectedVariantPropertyInput = formWrap.querySelector('[data-selected-variant-property]');
      // The quick-add modal renders price in a header row alongside the image/title,
      // outside .product-form (data-product-form) — so it isn't always a descendant of
      // formWrap. Search the nearest component wrapper instead, falling back to
      // formWrap itself for any other caller of this snippet.
      var priceScope = formWrap.closest('.quick-add, .product') || formWrap;
      var priceWrap = priceScope.querySelector('[data-product-price]');
      var stockWrap = formWrap.querySelector('[data-stock-badge-wrap]');
      var addBtn = formWrap.querySelector('[data-add-to-cart]');
      var addBtnText = addBtn && addBtn.querySelector('[data-add-to-cart-text]');
      var optionInputs = formWrap.querySelectorAll('[data-option-input]');
      var legends = formWrap.querySelectorAll('[data-selected-value]');

      // Stock size / Custom size choice + inches/cm switch.
      // Runs per product form, so it works the same in Quick add as on the product page.
      function initMeasurementForm(scope) {
        var mf = scope.querySelector('[data-measurement-form]');
        if (!mf || mf.dataset.mfInit) return;
        mf.dataset.mfInit = 'true';

        var IN_TO_CM = 2.54;
        var panel = mf.querySelector('[data-mf-panel]');
        var fields = mf.querySelectorAll('[data-mf-field]');
        var flags = mf.querySelectorAll('[data-mf-flag]');
        var unit = 'in';

        function setActive(group, active) {
          group.forEach(function (b) {
            var on = b === active;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }

        // Disabled inputs are not submitted — this is what keeps a plain stock-size
        // order free of measurement properties (and so free of a stitching job).
        function setCustom(on) {
          if (panel) panel.hidden = !on;
          fields.forEach(function (f) { f.disabled = !on; });
          flags.forEach(function (f) { f.disabled = !on; });
        }

        // In "variant" mode the Size picker is the control: selecting the untracked
        // "Custom" variant opens the measurements. Exposed so handleChange can call it
        // on every variant switch.
        if (mf.dataset.mfMode === 'variant') {
          var hint = mf.querySelector('[data-mf-hint]');
          mf.clothifyApplyVariant = function (variant) {
            var on = !!(variant && variant.title && /custom/i.test(variant.title));
            setCustom(on);
            if (hint) hint.hidden = on;
          };
          // Respect what Liquid already rendered: a ?variant= deep link to the Custom
          // variant arrives with the panel open, and forcing it shut here would both
          // hide it and strip the properties.
          setCustom(panel ? !panel.hidden : false);
        }

        var unitBtns = Array.prototype.slice.call(mf.querySelectorAll('[data-mf-unit]'));
        unitBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var next = btn.dataset.mfUnit;
            if (next === unit) return;
            setActive(unitBtns, btn);
            fields.forEach(function (f) {
              if (!f.dataset.mfLabel) return;
              var n = parseFloat(f.value);
              if (!isNaN(n)) {
                f.value = String(Math.round((next === 'cm' ? n * IN_TO_CM : n / IN_TO_CM) * 10) / 10);
              }
              // The unit rides along in the property key, so the ERP stores and shows
              // exactly what was measured rather than assuming inches.
              f.name = 'properties[' + f.dataset.mfLabel + ' (' + next + ')]';
            });
            mf.querySelectorAll('[data-mf-unit-label]').forEach(function (el) { el.textContent = next; });
            unit = next;
          });
        });

        // Numbers only: strip anything that isn't a digit or a single decimal point.
        fields.forEach(function (f) {
          if (f.type !== 'number') return;
          f.addEventListener('input', function () {
            var cleaned = f.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
            if (cleaned !== f.value) f.value = cleaned;
          });
        });
      }

      function clearMeasurementErrors() {
        var errorEl = formWrap.querySelector('[data-bespoke-error]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.hidden = true;
        }
        formWrap.querySelectorAll('.measurement-form .field__input, .measurement-form .field__textarea').forEach(function (field) {
          field.classList.remove('is-error');
          field.setAttribute('aria-invalid', 'false');
        });
      }

      function validateBespokeMeasurements(event) {
        if (!form) return true;
        // Measurements are required whenever the panel is actually active — always for
        // bespoke products, and for a stocked garment only once "Custom size" is chosen.
        // The flag input's disabled state is the single source of truth for that, since
        // it is also what decides whether the properties get submitted at all.
        var flag = form.querySelector('[data-mf-flag]');
        var active = flag ? !flag.disabled : form.hasAttribute('data-bespoke-form');
        if (!active) {
          clearMeasurementErrors();
          return true;
        }

        var requiredFields = form.querySelectorAll('[data-mf-required]');
        var missingFields = Array.prototype.filter.call(requiredFields, function (field) {
          return !field.value || field.value.trim() === '';
        });

        if (missingFields.length === 0) {
          clearMeasurementErrors();
          return true;
        }

        event.preventDefault();
        missingFields.forEach(function (field) {
          field.classList.add('is-error');
          field.setAttribute('aria-invalid', 'true');
        });

        // Which fields are required is now set per product/collection in Shopify
        // Admin (measurement-form.liquid), not fixed to chest/shoulder/waist — so the
        // message names whichever ones are actually missing rather than assuming.
        var missingLabels = missingFields
          .map(function (field) { return field.dataset.mfLabel; })
          .filter(Boolean);
        var fallback = missingLabels.length
          ? 'Please enter your ' + missingLabels.join(', ') + ' measurements before adding this bespoke item to your cart.'
          : 'Please enter the required measurements before adding this bespoke item to your cart.';
        var errorEl = formWrap.querySelector('[data-bespoke-error]');
        var message = theme.strings.measurementError || fallback;
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
        if (missingFields[0]) {
          missingFields[0].focus();
        }
        return false;
      }

      function currentSelection() {
        var selected = [];
        var groups = formWrap.querySelectorAll('.variant-picker__group[data-option-index]');
        groups.forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          var checked = group.querySelector('[data-option-input]:checked');
          selected[idx] = checked ? checked.value : undefined;
        });
        return selected;
      }

      function findVariant(selection) {
        return product.variants.find(function (v) {
          return v.options.every(function (val, i) { return val === selection[i]; });
        });
      }

      function syncVariantInputs() {
        var selection = currentSelection();
        var variant = findVariant(selection);

        if (variant) {
          variantIdInputs.forEach(function (el) { el.value = variant.id; });
          if (selectedVariantPropertyInput) selectedVariantPropertyInput.value = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        } else {
          variantIdInputs.forEach(function (el) { el.value = ''; });
          if (selectedVariantPropertyInput) selectedVariantPropertyInput.value = '';
        }

        return { selection: selection, variant: variant };
      }

      function updateAvailability(selection) {
        var groups = formWrap.querySelectorAll('.variant-picker__group[data-option-index]');
        groups.forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          group.querySelectorAll('[data-option-input]').forEach(function (input) {
            var test = selection.slice();
            test[idx] = input.value;
            var match = product.variants.find(function (v) {
              return v.options.every(function (val, i) { return test[i] == null || val === test[i]; });
            });
            input.disabled = !match;
          });
        });
      }

      function updateImage(variant) {
        if (!variant || !variant.featured_media) return;
        var mainImg = document.getElementById('ProductMainImage');
        var thumb = document.querySelector('[data-product-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) {
          document.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) mainImg.src = thumb.dataset.imageUrl;
        }
      }

      function updateLegends(selection) {
        legends.forEach(function (legend, i) {
          if (selection[i] != null) legend.textContent = selection[i];
        });
      }

      function handleChange() {
        var state = syncVariantInputs();
        var selection = state.selection;
        var variant = state.variant;

        updateLegends(selection);
        updateAvailability(selection);

        var mf = formWrap.querySelector('[data-measurement-form]');
        if (mf && mf.clothifyApplyVariant) mf.clothifyApplyVariant(variant);
        if (priceWrap) priceWrap.innerHTML = renderPriceHtml(variant, product);
        if (stockWrap) stockWrap.innerHTML = renderStockBadgeHtml(variant);

        if (variant) {
          updateImage(variant);
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, theme.moneyFormat);
        }

        if (addBtn) {
          var disabled = !variant || !variant.available;
          addBtn.disabled = disabled;
          if (addBtnText) {
            addBtnText.textContent = !variant ? theme.strings.unavailable : (!variant.available ? theme.strings.soldOut : theme.strings.addToCart);
          }
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', handleChange);
      });

      if (form) {
        form.clothifySyncSelectedVariant = function () {
          return syncVariantInputs().variant;
        };
        form.addEventListener('submit', validateBespokeMeasurements);
        form.querySelectorAll('[data-mf-required]').forEach(function (field) {
          field.addEventListener('input', function () {
            if (field.value && field.value.trim() !== '') {
              field.classList.remove('is-error');
              field.setAttribute('aria-invalid', 'false');
            }
          });
        });
        initMeasurementForm(formWrap);
      }

      // Thumbnail click -> swap main image
      document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        if (thumb.dataset.thumbInit) return;
        thumb.dataset.thumbInit = 'true';
        thumb.addEventListener('click', function () {
          document.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var mainImg = document.getElementById('ProductMainImage');
          if (mainImg) mainImg.src = thumb.dataset.imageUrl;
        });
      });
    });
  }

  window.ClothifyProduct = { init: initProductForm };

  document.addEventListener('DOMContentLoaded', function () {
    initProductForm(document);
    initStickyAtc();
  });

  /* ============================================================
     Sticky add-to-cart bar (mobile)
     ============================================================ */
  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var realBtn = document.querySelector('[data-product-form] [data-add-to-cart]');
    if (!sticky || !realBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20% 0px' });
    observer.observe(realBtn);

    var stickyBtn = sticky.querySelector('[data-sticky-add-to-cart]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (realBtn.disabled) return;
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { realBtn.click(); }, 350);
      });
    }
  }
})();
